var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalizeBill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4975 1.75C6.08327 1.75 5.7475 2.08579 5.7475 2.5V12.25H8.245V2.5C8.245 2.08578 7.90922 1.75 7.495 1.75H6.4975ZM9.745 12.25H11.5C11.9142 12.25 12.25 11.9142 12.25 11.5V5.5C12.25 5.08579 11.9142 4.75 11.5 4.75H9.745V12.25ZM9.745 3.25V2.5C9.745 1.25736 8.73767 0.25 7.495 0.25H6.4975C5.25486 0.25 4.2475 1.25736 4.2475 2.5V6.25H2.5C1.25735 6.25 0.25 7.25733 0.25 8.5V11.5C0.25 12.7427 1.25736 13.75 2.5 13.75H11.5C12.7427 13.75 13.75 12.7427 13.75 11.5V5.5C13.75 4.25736 12.7427 3.25 11.5 3.25H9.745ZM4.2475 7.75H2.5C2.08578 7.75 1.75 8.08577 1.75 8.5V11.5C1.75 11.9142 2.08579 12.25 2.5 12.25H4.2475V7.75Z",
    fill: "#76D0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalizeBill);
export default __webpack_public_path__ + "static/media/analizeBill.5db6af829a3f284b7663083234553443.svg";
export { ForwardRef as ReactComponent };